import { render, staticRenderFns } from "./add-Agreesetting.vue?vue&type=template&id=8dbc871e&scoped=true"
import script from "./add-Agreesetting.vue?vue&type=script&lang=js"
export * from "./add-Agreesetting.vue?vue&type=script&lang=js"
import style0 from "./add-Agreesetting.vue?vue&type=style&index=0&id=8dbc871e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbc871e",
  null
  
)

export default component.exports